import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'thousandsNOK' })
export class ThousandsNOKPipe implements PipeTransform {
  transform(value: number | string): string {
    if (value || value === 0) {
      return (+value).toLocaleString('nb') + ' NOK';
    }
    return '';
  }
}
